import React, { ChangeEvent } from 'react';

interface SelectColumnsProps {
  data: any[];
  selectedColumns: string[];
  setSelectedColumns: any;
}

export const SelectColumns: React.FC<SelectColumnsProps> = ({ data, selectedColumns, setSelectedColumns }) => {
  const handleColumnToggle = (columnTitle: string) => {
    setSelectedColumns((prevSelectedColumns:any) => {
      if (prevSelectedColumns.includes(columnTitle)) {
        return prevSelectedColumns.filter((title:string) => title !== columnTitle);
      } else {
        return [...prevSelectedColumns, columnTitle];
      }
    });
  };
  return (
    <div className="column-selector">
        {data && data[0] && data[0].map((item: any, index: number) => (
          <label key={index}>
            <input
              type="checkbox"
              checked={selectedColumns.includes(item.title)}
              onChange={() => handleColumnToggle(item.title)}
            />
            {item.title.toUpperCase()}
          </label>
        ))}
      </div>
  );
};
